import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Button, Popconfirm, Divider, message } from 'antd';
import cloneDeep from 'lodash.clonedeep';
import { setPromotionsToState } from '../../../actions/dataForState/setPromotionsToState';
import { getPromotions, getConfig, getIsSavingPromotions, getIsSavedPromotions } from '../../../reducers';
import LoadingPage from '../../../components/LoadingPage';
import PromotionsAdminComponent from '../../../components/PromotionsAdminComponent';
import { storage } from '../../../config/Fire';
import { updatePromotions, setSavedPromotions } from '../../../actions/dataForState/updatePromotions';
import { setConfig } from '../../../actions/setConfig';
import FormNewPromotion from '../../../components/FormNewPromotion';
import PromotionsTableAdmin from '../../../components/tables/PromotionsTableAdmin';

function compareUid( a, b ) {
    const uidA = a.uid;
    const uidB = b.uid;
    if ( uidA < uidB ) {
      return -1;
    }
    if ( uidA > uidB ) {
      return 1;
    }
    return 0;
};

class PromotionsAdmin extends Component {
    state = {
        types: {},
        fileTypePromotion: [],
        categorySelected: null,
        typePositionSelected: null,
        isLoadingIcon: false,
        fileIcons: [],
        areIconsLoaded: false,
        isAddCategory: false,
        isAddItem: false,
    }

    onCategorySelected = value => {
        const { promotions } = this.props;
        this.setState({ types: promotions[value], categorySelected: value, typePositionSelected: null });
    }

    onTypeSelected = value => {
        const { promotions } = this.props;
        if(promotions[this.state.categorySelected] && promotions[this.state.categorySelected][value] && promotions[this.state.categorySelected][value].icon !== "") {
            this.setState({ isLoadingIcon: true, typePositionSelected: value });
            var imagesProfile = [];
            this.state.fileIcons.forEach(icon => {
                if(promotions[this.state.categorySelected][value].icon === icon.name) {
                    imagesProfile.push(icon);
                    this.setState({ fileTypePromotion: imagesProfile, isLoadingIcon: false });
                }
            });
        }
    }

    removeCategory = () => {
        const promos = cloneDeep(this.props.promotions);
        if(promos[this.state.categorySelected]) {
            delete promos[this.state.categorySelected];
            this.props.updatePromotions({ promotions: promos });
        }
    }

    removeType = () => {
        const promos = cloneDeep(this.props.promotions);
        if(promos[this.state.categorySelected] && promos[this.state.categorySelected][this.state.typePositionSelected]) {
            promos[this.state.categorySelected].splice(this.state.typePositionSelected, 1);
            if(promos[this.state.categorySelected] === null || promos[this.state.categorySelected].length === 0) {
                delete promos[this.state.categorySelected];
            }
            this.props.updatePromotions({ promotions: promos });
        }
    }

    getPromotionsKeys = () => {
        const { promotions } = this.props;
        var keys = Object.keys(promotions);
        Object.keys(promotions).forEach((promotion, index) => {
            if(!promotions[keys[index]] || promotions[keys[index]].length === 0) {
                keys.splice(index, 1);
            }
        });
        return keys;
    }

    getIconsStorage = () => {
        const { config } = this.props;
        console.log("getIconsStorage")
        if(config.promos && config.promos.icons) {
            var fileIcons = [];
            return config.promos.icons.forEach((element, index) => {
                return storage.ref().child(element).getDownloadURL().then(url => {
                    fileIcons.push({ uid: index, name: element, status: 'done', url: url });
                    if(fileIcons.length === config.promos.icons.length) {
                        fileIcons.sort(compareUid);
                        this.setState({ fileIcons: fileIcons, areIconsLoaded: true });
                    }
                });
            });
        }
    }

    onAddCategory = () => {
        this.setState({ isAddCategory: true, isAddItem: false });
    }

    onAddType = () => {
        this.setState({ isAddCategory: false, isAddItem: true });
    }

    handleSubmitCategory = values => {
        const promos = cloneDeep(this.props.promotions);
        if(promos[values.field_category] !== undefined) {
            message.error('La categoría ingresada ya existe. Por favor, ingrese otra o de lo contrario utlice la existente.');
        } else {
            if(/[@#$^&*()_+\-=[\]{};':"\\|,.<>£/?]/.test(values.field_category)) {
                message.error('La categoría ingresada no puede contener los siguientes caracteres: @#$^&*()_+-=[]{};\':"\\|,.<>£/?.');
            } else {
                this.saveNewCategory(values);
            }
        }
    }

    saveNewCategory = values => {
        const promos = cloneDeep(this.props.promotions);
        promos[values.field_category] = [];
        promos[values.field_category].push({ icon: values.field_icon, text: values.field_type })
        this.props.updatePromotions({ promotions: promos });
    }

    handleSubmitType = values => {
        this.saveNewType(values);
    }

    saveNewType = values => {
        const promos = cloneDeep(this.props.promotions);
        promos[values.field_category].push({ icon: values.field_icon, text: values.field_type })
        this.props.updatePromotions({ promotions: promos });
    }

    handleExitAddForm = () => {
        this.setState({ isAddCategory: false, isAddItem: false });
    }

    renderSavedPromotions = () => {
        message.success('¡Los cambios se guardaron exitósamente!');
        var isSavedPromotions = false;
        this.props.setSavedPromotions(isSavedPromotions);
        this.setState({ fileTypePromotion: [], isAddCategory: false, isAddItem: false, types: {}, categorySelected: null });
        return;
    }
    
    renderTablePromotions = promotions => {
        var data = [];
        for (var key in promotions) {
            // eslint-disable-next-line no-loop-func
            promotions[key].forEach(promo => {
                var isPromoWithIcon = false;
                this.state.fileIcons.forEach(icon => {
                    if(icon.name === promo.icon) {
                        isPromoWithIcon = true;
                        data.push({ text: key, description: promo.text, icon: icon });
                    }
                });
                if(!isPromoWithIcon) {
                    data.push({ text: key, description: promo.text, icon: null });
                }
            });
        }
        return (<PromotionsTableAdmin data={data} />);
    }

    isInfoLoaded = () => {
        const { promotions, config } = this.props;
        if(promotions && config) {
            return true;
        } else {
            return false;
        }
    }

    getInfo = () => {
        const { setPromotions, promotions, setConfig, config } = this.props;
        if(!promotions) {
            setPromotions();
        }
        if(!config) {
            setConfig();
        }
        return (<LoadingPage />);
    }

    render() {
        const { isSavingPromotions } = this.props;
        return (
            <div>
                {
                    this.isInfoLoaded() ?
                        <Grid>
                            {
                                this.state.fileIcons.length === 0 && this.getIconsStorage()
                            }
                            <Row>
                                <Col>
                                    <PromotionsAdminComponent onExit={this.props.onExitPromotions} categoriesOfPromotions={this.getPromotionsKeys()} onCategorySelected={this.onCategorySelected} typesOfCategory={this.state.types} onTypeSelected={this.onTypeSelected} fileTypePromotion={this.state.fileTypePromotion} isLoadingIcon={this.state.isLoadingIcon} isSavedPromotions={this.props.isSavedPromotions}/>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={1} sm={2} md={4}></Col>
                                <Col xs={5} sm={4} md={2}>
                                    {
                                        this.state.categorySelected ?
                                            isSavingPromotions ?
                                                <Button disabled={true} loading>Guardando</Button>
                                                :
                                                <Popconfirm title="¿Desea borrar la categoría?" okText="SI" cancelText="NO" onConfirm={this.removeCategory}>
                                                    <Button>Borrar categoría</Button>
                                                </Popconfirm>
                                            :
                                            <Button disabled={true}>Borrar categoría</Button>
                                    }
                                </Col>
                                <Col xs={5} sm={4} md={2}>
                                    {
                                        this.state.typePositionSelected !== null ?
                                            isSavingPromotions ?
                                                <Button disabled={true} loading>Guardando</Button>
                                                :
                                                <Popconfirm title="¿Desea borrar el ítem?" okText="SI" cancelText="NO" onConfirm={this.removeType}>
                                                    <Button disabled={isSavingPromotions}>Borrar ítem</Button>
                                                </Popconfirm>
                                            :
                                            <Button disabled={true}>Borrar ítem</Button>

                                    }
                                </Col>
                                <Col xs={1} sm={2} md={4}></Col>
                            </Row>
                            <Divider>Agregar</Divider>
                            {
                                this.state.isAddCategory ?
                                <Row center="xs">
                                    <Col>
                                        <FormNewPromotion categoriesOfPromotions={this.getPromotionsKeys()} isNewCategory={true} isSaving={this.props.isSavingPromotions} isSavedPromotions={this.props.isSavedPromotions} fileIcons={this.state.fileIcons} onSubmit={this.handleSubmitCategory} onExit={this.handleExitAddForm}/>
                                    </Col>
                                </Row>
                                :
                                this.state.isAddItem ?
                                    <Row center="xs">
                                        <Col>
                                            <FormNewPromotion categoriesOfPromotions={this.getPromotionsKeys()} isNewCategory={false} isSaving={this.props.isSavingPromotions} isSavedPromotions={this.props.isSavedPromotions} fileIcons={this.state.fileIcons} onSubmit={this.handleSubmitType} onExit={this.handleExitAddForm}/>
                                        </Col>
                                    </Row>
                                    :
                                    <Row center="xs">
                                        <Col xs={1} sm={2} md={4}></Col>
                                        <Col xs={5} sm={4} md={2}>
                                            <Button onClick={this.onAddCategory}>Categoría</Button>
                                        </Col>
                                        <Col xs={5} sm={4} md={2}>
                                            <Button onClick={this.onAddType}>Item</Button>
                                        </Col>
                                        <Col xs={1} sm={2} md={4}></Col>
                                    </Row>
                            }
                            <Divider>Existentes</Divider>
                            {
                                this.state.areIconsLoaded ?
                                    this.renderTablePromotions(this.props.promotions)
                                    :
                                    <LoadingPage />
                            }
                            {
                                    this.props.isSavedPromotions && this.renderSavedPromotions()
                            }
                        </Grid>
                        :
                        this.getInfo()
                }
            </div>
        );
    }
}

PromotionsAdmin.propTypes = {
    onExitPromotions: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setConfig: value => dispatch(setConfig(value)),
    setPromotions: value => dispatch(setPromotionsToState(value)),
    updatePromotions: value => dispatch(updatePromotions(value)),
    setSavedPromotions: value => dispatch(setSavedPromotions(value)),
});

const mapStateToProps = state => ({
    promotions: getPromotions(state),
    config: getConfig(state),
    isSavingPromotions: getIsSavingPromotions(state),
    isSavedPromotions: getIsSavedPromotions(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(PromotionsAdmin));